import { Button } from "antd";
import CustomModal from "components/CustomModal";
import { t } from "i18next";
import React from "react";
import useModalCreateOrder from "./useModalCreateOrder";

const ModalCreateOrder = ({ data, form }) => {
  const { validateCreateOrder, onOpenCreateOrder, isVisible, onCancel, onCreateOrder, loading, isMissingPickupInfo } =
    useModalCreateOrder({ data, form });
  const { title, hideConfirmButton } = validateCreateOrder();

  return (
    <div style={isMissingPickupInfo ? { pointerEvents: "none" } : undefined}>
      <CustomModal
        customComponent={
          <Button type="primary" disabled={isMissingPickupInfo}>
            {t("cart.createOrder")}
          </Button>
        }
        title={<b>{title}</b>}
        footer={false}
        centered={true}
        hideConfirmButton={hideConfirmButton}
        onOpen={onOpenCreateOrder}
        onCancel={onCancel}
        onOke={onCreateOrder}
        buttonLoading={loading}
      />
    </div>
  );
};

export default ModalCreateOrder;
